import { render, staticRenderFns } from "./FormSearchPerinta.vue?vue&type=template&id=660fbe43&scoped=true&"
import script from "./FormSearchPerinta.vue?vue&type=script&lang=js&"
export * from "./FormSearchPerinta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660fbe43",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('660fbe43')) {
      api.createRecord('660fbe43', component.options)
    } else {
      api.reload('660fbe43', component.options)
    }
    module.hot.accept("./FormSearchPerinta.vue?vue&type=template&id=660fbe43&scoped=true&", function () {
      api.rerender('660fbe43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormSearchPerinta.vue"
export default component.exports